import React, { useMemo } from 'react';
import {
	costVarianceSortOptions,
	dispatchSortOptions,
	dropDownItems, indentSortOptions, IssuedSortOptions, producedSortOptions
} from './table.constants';

/* eslint-disable*/
export const getDynamicColumnMapAndColumns = (data, excludeColumn = [], type = 'weight', tableTab = '') => {
	const items = Object.values(data?.items || {});
	const columnPairs = items?.flatMap((item) => Object.values(item?.pods || {})?.map((obj) => [String(obj?.podId), obj?.podName]));
	const uniqueColumn = new Map();
	if (tableTab === 'sfg') {
		uniqueColumn.set('intermediateName', 'Intermediate Name');
	} else {
		uniqueColumn.set('ingredientName', 'Ingredient Name');
	}
	uniqueColumn.set('total', type === 'weight' ? 'Total Weight' : 'Total Cost');
	columnPairs?.forEach(([podId, podName]) => {
		if (!uniqueColumn.has(podId)) {
			uniqueColumn.set(podId, podName);
		}
	});
	let tableColumns = Array.from(uniqueColumn, ([key, title]) => {
		if (key === 'total' || key === 'ingredientName') {
			return {
				title,
				key,
				customCol: true,
				fixed: true,
				sortable: true
			};
		}
		return {
			title,
			key,
			customCol: true,
			sortable: true
		};
	});
	if (excludeColumn?.length > 0) {
		tableColumns = tableColumns?.filter((column) => !excludeColumn?.includes(column?.key || column?.title));
	}
	return {
		colMap: uniqueColumn, columns: tableColumns,
	};
};

export const getVariance = (productData) => {
	let totalHighVariance = 0;
	let totalLowVariance = 0;

	Object.values(productData?.pods || {})?.forEach((item) => {
		const orderCost = item?.orderQty * item?.rate;
		const diffOrderedCostFullfilledCost = Number(Math.abs(orderCost - item?.fullfilledCost).toFixed(0));

		if (diffOrderedCostFullfilledCost != 0 && Math.abs((item?.fullfilledCost - orderCost) / orderCost) > 0.05) {
			if (orderCost < item?.fullfilledCost) {
				totalHighVariance += diffOrderedCostFullfilledCost;
			} else {
				totalLowVariance += diffOrderedCostFullfilledCost;
			}
		}
	});

	return totalHighVariance > totalLowVariance ? "high" : "low";
};

export const getStructuredData = (data, mode = '', productDataList = {}, actualProductPrice = {}) => {
	let convertData = [];
	const podMap = new Map();
	if (mode === 'issuedSummary') {
		Object.entries(productDataList || {}).forEach(([itemId, item]) => {
			if (itemId) {
				const totalIssuedQty = Object.values(item?.pods || {})?.reduce?.((acc, item) => acc + item?.ingData?.reduce((acc, item) => acc + (item?.fullfilledQty || 0), 0), 0);
				const totalOrderQty = Object.values(item?.pods || {})?.reduce?.((acc, item) => acc + item?.ingData?.reduce((acc, item) => acc + (item?.orderQty || 0), 0), 0);
				const issuingPercentage = totalOrderQty > 0 ? (totalIssuedQty / totalOrderQty) * 100 : 0;
				const unit = Object.values(item?.pods || {})?.[0]?.ingData?.[0]?.unit;
				const totalFulfilledCost = Object.values(item?.pods || {})?.reduce?.((acc, item) => acc + item?.ingData?.reduce((acc, item) => acc + (item?.fullfilledCost || 0), 0), 0);
				const totalOrderCost = Object.values(item?.pods || {})?.reduce?.((acc, item) => acc + item?.ingData?.reduce((acc, item) => acc + ((item?.orderQty * item?.rate) || 0), 0), 0);
				const variance = getVariance(item);
				if (!podMap.has(itemId)) {
					podMap.set(itemId, {
						podId: Object.values(data?.items || {})
							.flatMap((podItem) => Object.values(podItem?.pods || {}))
							.find((pod) => pod?.podName === item?.itemName)?.podId,
						podName: item?.itemName,
						kitchenName: Object.values(item?.pods)?.[0]?.kitchenName,
						scheduledAt: Object.values(item?.pods)?.[0]?.scheduledAt,
						fullfilledPercentage: issuingPercentage?.toFixed(2),
						totalWeight: `${totalIssuedQty?.toFixed(2)} ${unit} / ${totalOrderQty?.toFixed(2)} ${unit}`,
						totalCost: `${totalFulfilledCost?.toFixed(2)} ${unit} / ${totalOrderCost?.toFixed(2)} ${unit}`,
						idealCost: `${(totalOrderCost / totalOrderQty)?.toFixed(2)} /${unit}`,
						variance,
						allIngredients: Object.values(data?.items || {})
							.flatMap((podItem) =>
								Object.values(podItem?.pods || {})
									.filter((pod) => pod?.podName === item?.itemName)
									.map((pod) => ({
										ingName: podItem?.itemName,
										itemClientVariantId: podItem?.itemClientVariantId,
										...pod,
									}))
							)
					});
				}
			}
		});
	} else {
		Object.entries(data?.items || {}).forEach(([itemId, item]) => {
			Object.values(item?.pods || {}).forEach((pod) => {
				if (pod?.podId) {
					if (!podMap.has(pod.podId)) {
						podMap.set(pod.podId, {
							podId: pod.podId,
							podName: pod.podName,
							kitchenName: pod.kitchenName,
							scheduledAt: pod.scheduledAt,
							poIds: pod?.poIds,
							allIngredients: []
						});
					}
					podMap.get(pod.podId).allIngredients.push({
						ingName: item?.itemName,
						itemClientVariantId: item?.itemClientVariantId,
						actualRate: actualProductPrice?.[item?.itemName] || 0,
						...pod
					});
				}
			});
		});
	}
	convertData = Array.from(podMap.values());
	return convertData;
}
export const getConvertedData = (data, mode = '', productList = {}, poInfoById = {}, actualProductPrice = {}) => {
	if (mode === 'produced') {
		const refactorData = getStructuredData(data, undefined, undefined, actualProductPrice);
		const convertedData = refactorData?.map((product) => {
			const totalOrderQty = product?.allIngredients?.reduce((acc, item) =>
				acc + (
					item?.ingData?.reduce(
						(subAcc, ingredient) =>
							(ingredient?.unit === 'kg' ? subAcc + (ingredient?.orderQty || 0) : subAcc)
						, 0
					) || 0
				), 0
			);
			const totalFullfilledQty = product?.allIngredients?.reduce((acc, item) =>
				acc + (
					item?.ingData?.reduce(
						(subAcc, ingredient) =>
							(ingredient?.unit === 'kg' ? subAcc + (ingredient?.fullfilledQty || 0) : subAcc)
						, 0
					) || 0
				), 0
			);
			const totalPackagedCost = product?.allIngredients?.reduce((acc, item) => acc + (item?.packagedCost || 0), 0);
			const unit = product?.allIngredients?.[0]?.unit;
			return {
				headerInfo: {
					podId: product?.podId,
					podName: product?.podName,
					totalPackagingPercentage: totalFullfilledQty / totalOrderQty * 100,
					totalPackagedCost: totalPackagedCost,
					totalOrderedWeight: totalOrderQty,
					totalPackagedWeight: totalFullfilledQty,
					unit: unit,
				},
				list: product?.allIngredients
			}
		})
		return convertedData;
	}
	if (mode === 'restaurantIndent') {
		const refactorData = getStructuredData(data, undefined, undefined, actualProductPrice);
		const convertedData = refactorData?.map((product) => {
			const unit = product?.allIngredients?.[0]?.unit;
			return {
				headerInfo: {
					podId: product?.podId,
					podName: product?.podName,
					orderedQty: product?.allIngredients?.reduce((acc, item) => acc + item?.orderQty, 0),
					dispatchedQty: product?.allIngredients?.reduce((acc, item) => acc + item?.fullfilledQty, 0),
					leftOverQty: product?.allIngredients?.reduce((acc, item) => acc + item?.leftOverQty, 0),
					consumedQty: product?.allIngredients?.reduce((acc, item) => acc + item?.consumptionQty, 0),
					orderedCost: product?.allIngredients?.reduce((acc, item) => acc + (item?.orderCost ?? item?.orderQty * item?.rate), 0),
					dispatchedCost: product?.allIngredients?.reduce((acc, item) => acc + (item?.fullfilledCost ?? item?.fullfilledQty * item?.rate), 0),
					leftOverCost: product?.allIngredients?.reduce((acc, item) => acc + (item?.leftOverCost ?? item?.leftOverQty * item?.rate), 0),
					consumedCost: product?.allIngredients?.reduce((acc, item) => acc + (item?.consumptionCost ?? item?.consumptionQty * item?.rate), 0),
					unit: unit,
				},
				list: product?.allIngredients
			}
		})
		return convertedData;
	}
	if (mode === 'issuedSummary') {
		const refactorData = getStructuredData(data, 'issuedSummary', productList);
		const convertedData = refactorData?.map((product) => {
			const unit = product?.allIngredients?.[0]?.unit;
			return {
				headerInfo: {
					podId: product.podId,
					podName: product.podName,
					kitchenName: product.kitchenName,
					scheduledAt: product.scheduledAt,
					fullfilledPercentage: product.fullfilledPercentage,
					totalWeight: product.totalWeight,
					totalCost: product.totalCost,
					idealCost: product.idealCost,
					variance: product.variance,
					unit: unit,
				},
				list: product?.allIngredients
			}
		})
		return convertedData;
	}
	if (mode === 'dispatched') {
		const refactorData = getStructuredData(data, undefined, undefined, actualProductPrice);
		const convertedData = refactorData?.map((product) => {
			return {
				headerInfo: {
					podId: product?.podId,
					podName: product?.podName,
					totalPackagedCost: product?.allIngredients?.reduce((acc, item) => acc + (item?.packagedCost ?? 0), 0),
					totalDispatchedCost: product?.allIngredients?.reduce((acc, item) => acc + (item?.fullfilledCost ?? 0), 0),
					totalReceivedCost: product?.allIngredients?.reduce((acc, item) => acc + (item?.receivedCost ?? 0), 0),
					totalOrderedQty: product?.allIngredients?.reduce((acc, item) => acc + (item?.orderQty ?? 0), 0),
					totalDispatchedQty: product?.allIngredients?.reduce((acc, item) => acc + (item?.fullfilledQty ?? 0), 0),
					totalReceivedQty: product?.allIngredients?.reduce((acc, item) => acc + (item?.received ?? 0), 0),
					unit: product?.allIngredients?.[0]?.unit,
				},
				list: product?.allIngredients,
				poDetails: product?.poIds?.map((id) => poInfoById?.[id]),
			}
		})
		return convertedData;
	}
}
export const useSessionStorageList = () => {
	return useMemo(() => {
		try {
			const storedList = sessionStorage.getItem('aiFmsProductList');
			return storedList ? JSON.parse(storedList) : [];
		} catch (error) {
			console.error('Error parsing aiFmsProductList from sessionStorage:', error);
			return [];
		}
	}, []);
};

export const commaForAmount = (amount) => {
	if (isNaN(amount)) return '0';
	return Number(amount).toLocaleString('en-IN');
}

export const getTextColor = (totalIssuedQty, totalOrderQty) => {
	if (parseFloat(totalIssuedQty) === parseFloat(totalOrderQty)) return 'text-[#1B7F3A]';
	if (parseFloat(totalIssuedQty) < parseFloat(totalOrderQty)) return 'text-[#D97706]';
	if (parseFloat(totalIssuedQty) > parseFloat(totalOrderQty)) return 'text-[#D32F2F]';
	return 'text-black';
}

export const getTooltipTitle = (totalIssuedQty, totalOrderQty, mode) => {
	if (parseFloat(totalIssuedQty) === parseFloat(totalOrderQty)) return mode === 'produced' ? 'Exact Produced' : 'Exact Issued';
	if (parseFloat(totalIssuedQty) < parseFloat(totalOrderQty)) return mode === 'produced' ? 'Under Produced' : 'Under Issued';
	if (parseFloat(totalIssuedQty) > parseFloat(totalOrderQty)) return mode === 'produced' ? 'Over Produced' : 'Over Issued';
	return null;
}

export const getDropDowns = (parentTab, subParentTab) => {
	if (parentTab?.id === 1) {
		if (subParentTab?.id === 1) {
			return dropDownItems?.filter((item) => ['ingredientName', 'name'].includes(item?.value));
		} else if (subParentTab?.id === 2) {
			return dropDownItems?.filter((item) => ['sectionName'].includes(item?.value));
		}
		return dropDownItems?.filter((item) => ['ingredientName', 'name'].includes(item?.value));
	} else if (parentTab?.id === 2) {
		return dropDownItems?.filter((item) => ['outletName', 'name', 'intermediateName'].includes(item?.value));
	} else if (parentTab?.id === 3) {
		return dropDownItems?.filter((item) => ['outletName'].includes(item?.value));
	}
	return [];
}
export const getSortOptions = (parentTab, selectedTab, tableTab, subParentTab) => {
	if (parentTab?.id === 1) {
		if (subParentTab?.id === 1) {
			if (selectedTab === 'weight') {
				if (tableTab === 'products') {
					return IssuedSortOptions?.productWeight;
				}
			}
			if (selectedTab === 'cost') {
				if (tableTab === 'products') {
					return IssuedSortOptions?.productCost;
				}
				if (tableTab === 'rawMaterials') {
					return costVarianceSortOptions;
				}
			}
		}
		if (subParentTab?.id === 2) {
			if (selectedTab === 'weight') {
				if (tableTab === 'section') {
					return indentSortOptions?.sectionWeight;
				}
			}
			if (selectedTab === 'cost') {
				if (tableTab === 'section') {
					return indentSortOptions?.sectionCost;
				}
			}
		}
	}
	if (parentTab?.id === 2) {
		if (selectedTab === 'weight') {
			if (tableTab === 'outlets') {
				return producedSortOptions?.outletWeight;
			}
		}
		if (selectedTab === 'cost') {
			if (tableTab === 'outlets') {
				return producedSortOptions?.outletCost;
			}
			if (tableTab === 'products' || tableTab === 'sfg') {
				return costVarianceSortOptions;
			}
		}
	}
	if (parentTab?.id === 3) {
		if (selectedTab === 'weight') {
			if (tableTab === 'outlets') {
				return dispatchSortOptions?.outletWeight;
			}
		}
		if (selectedTab === 'cost') {
			if (tableTab === 'outlets') {
				return dispatchSortOptions?.outletCost;
			}
		}
	}
	return [];
}

export const extractNumeric = (text) => {
	if (!text) return NaN;
	const num = parseFloat(String(text).replace(/[^\d.-]/g, ''));
	return isNaN(num) ? NaN : num;
};

export const getTextFromElement = (element) => {
	if (!React.isValidElement(element)) return element;
	const { children } = element.props;

	if (Array.isArray(children)) {
		return children.map(getTextFromElement).join('');
	}
	if (React.isValidElement(children)) {
		return getTextFromElement(children);
	}
	return children ?? '';
};

export const getFirstChildText = (element) => {
	if (!React.isValidElement(element)) return element;

	const { children } = element.props;

	if (Array.isArray(children)) {
		const first = children[0];
		if (React.isValidElement(first)) {
			return getFirstChildText(first);
		}
		return first ?? '';
	}

	if (React.isValidElement(children)) {
		return getFirstChildText(children);
	}

	return children ?? '';
}

export const getFilteredData = (data, search) => {
	let filterData = data;
	if (search?.value === 'ingredientName') {
		filterData = data.filter((item) => (item?.itemName?.toLowerCase().includes(search?.searchValue?.toLowerCase()) || item?.itemClientVariantId?.toLowerCase().includes(search?.value?.toLowerCase())));
	}
	if (search?.value === 'name') {
		filterData = data.filter((item) => (item?.itemName?.toLowerCase().includes(search?.searchValue?.toLowerCase()) || item?.itemClientVariantId?.toLowerCase().includes(search?.value?.toLowerCase())));
	}
	if (search?.value === 'intermediateName') {
		filterData = data.filter((item) => (item?.itemName?.toLowerCase().includes(search?.searchValue?.toLowerCase()) || item?.itemClientVariantId?.toLowerCase().includes(search?.value?.toLowerCase())));
	}
	return filterData;
}

export const getfilteredWastageData = (data, search) => {
	if (!search?.searchValue) {
		return Object.values(data);
	}
	const lowerSearch = search?.searchValue?.toLowerCase();
	return Object.values(data).filter(item =>
		item?.itemName?.toLowerCase().includes(lowerSearch)
	);
}

export const getDynamicWastageColumns = (data, type) => {
	const uniqueColumn = new Map();
	uniqueColumn.set('itemList', 'Item List');
	uniqueColumn.set('total', 'Total Wastage');
	Object.entries(data)?.forEach(([key, values]) => {
		Object.entries(values)?.forEach(([valKey, val]) => {
			if (valKey === type) {
				val?.forEach((item) => {
					if (!uniqueColumn.has(item?.name)) {
						uniqueColumn.set(item?.name, item?.name);
					}
				})
			}
		})
	});
	let tableColumns = Array.from(uniqueColumn, ([key, title]) => {
		if (key === 'total' || key === 'itemList') {
			return {
				title,
				key,
				customCol: true,
				fixed: true,
				sortable: true
			};
		}
		return {
			title,
			key,
			customCol: true,
		};
	});
	return { tableColumns };
}

export const getRowIndex = (data, itemId, generatedData = false, active = {}, parentTabId = '') => {
	let result = [];
	if (generatedData) {
		let convertData = [];
		const podMap = new Map();
		Object.entries(data?.items || {}).forEach(([itemId, item]) => {
			Object.values(item?.pods || {}).forEach((pod) => {
				if (pod?.podId) {
					if (!podMap.has(pod.podId)) {
						podMap.set(pod.podId, {
							podId: pod.podId,
							podName: pod.podName,
							kitchenName: pod.kitchenName,
							scheduledAt: pod.scheduledAt,
							meal: active?.shiftName,
							poIds: pod?.poIds,
							allIngredients: [],
						});
					}
					podMap.get(pod.podId).allIngredients.push({
						ingName: item?.itemName,
						itemClientVariantId: item?.itemClientVariantId,
						...pod,
					});
				}
			});
		});
		convertData = Array.from(podMap.values());

		result = convertData ?? [];
	} else {
		result = Object.values(data) ?? [];
	}
	if (parentTabId === 2 || parentTabId === 3 || parentTabId === 4) {
		return result?.findIndex((item) => item?.podId == itemId);
	}
	return result?.findIndex((item) => item?.itemId == itemId);
}

export const getActualProductPrice = (data) => {
	const cost = {};
	const pack = {};
	const actualPrice = {};
	const idealCost = {};
	const orderQty = {};
	const totalOrderCost = {};
	Object.values(data).forEach((item) => {
		Object.entries(item?.pods).forEach(([key, pod]) => {
			let totalCost = 0;
			let orderCost = 0
			const totalPacked = parseFloat(pod?.packaged)
			pod?.ingData?.forEach((value) => {
				totalCost += parseFloat(value?.fullfilledCost);
				orderCost += parseFloat(value?.orderQty) * (parseFloat(value?.rate || 0));
			});
			cost[key] = {
				fullfiled: (cost[key]?.fullfiled || 0) + totalCost,
				name: pod?.podName
			}
			pack[key] = totalPacked
			totalOrderCost[key] = (totalOrderCost[key] || 0) + orderCost;
			orderQty[key] = {
				qty: pod?.orderQty,
				name: pod?.podName,
			}
		})
	})
	Object.entries(cost).forEach(([key, value]) => {
		const packed = pack[key] || 0;
		actualPrice[value?.name] = packed > 0 ? value?.fullfiled / packed : 0;
	})
	Object.entries(orderQty).forEach(([key, value]) => {
		idealCost[value?.name] = parseFloat(totalOrderCost[key]) / parseFloat(value?.qty) || 0;
	})
	return { actualPrice, idealCost }
}

export const getActiveTabForFetch = (parentTab, subParentTab) => {
	if (parentTab?.id === 1) {
		return subParentTab;
	}
	return parentTab;
};

export const getTabInfoBySubTabs = (parentTab, subParentTab) => {
	if (parentTab?.id === 1) {
		if (subParentTab?.id === 1) {
			return tableTabsIssuedSummary;
		}
		return tableTabsProducedSummary;
	}
	return null;
};